package pwgs.ui.scenes.logoutscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(LogoutSceneProps::class, LogoutSceneModel::class)
interface Logout {
    fun logout(redirectUrl: String)
}

@Serializable
class LogoutSceneProps {

}

@Serializable
class LogoutSceneModel() {
    var logoutUrl: String? = null
}